
<kendo-dialog-titlebar>
  <div style="font-size: 18px; line-height: 1.3em;">
    <span class="k-icon k-font-icon k-icon-xl k-i-form-element"></span> {{title}}
  </div>
</kendo-dialog-titlebar>

<form [formGroup]="disciplineSubscaleForm"  class="k-form-inline">

  <div class="k-form-field">
    <label class="form-label col-3 k-label" for="subscale_description">Discipline Subscale Description</label>
    <div class="col-8">
      <input type="text" id="subscale_description" formControlName="subscale_description" class="form-control" appAutoFocus>
      <div *ngIf="subscale_description?.invalid" class="alert alert-danger">
        <div *ngIf="subscale_description?.errors?.['required']">Discipline Subscale Description required.</div>
      </div>
    </div>
  </div>


</form>

<kendo-dialog-actions>
  <button kendoButton (click)="onSaveAction()" class="btn btn-primary" [disabled]="disciplineSubscaleForm.invalid">Save</button>
  <button kendoButton (click)="onCancelAction()" class="btn btn-secondary">Cancel</button>
</kendo-dialog-actions>

